import {
  Mail,
  Users,
  Clock4,
  EyeOff,
  AlertTriangle,
  RefreshCw,
} from "lucide-react";

const PROBLEMS = [
  {
    icon: Mail,
    title: "Too Many Emails",
    desc: "Bookings buried inside endless reply chains between teams, carriers and forwarders.",
  },
  {
    icon: Users,
    title: "Multiple Carrier Contacts",
    desc: "Coordinating MSC, Maersk, CMA CGM and more across disconnected portals and reps.",
  },
  {
    icon: Clock4,
    title: "Booking Delays",
    desc: "Manual confirmation loops that stretch from hours into days while ships fill up.",
  },
  {
    icon: EyeOff,
    title: "Limited Visibility",
    desc: "No single source of truth between purchase order, container and vessel.",
  },
  {
    icon: AlertTriangle,
    title: "Unexpected Changes",
    desc: "Roll-overs, vessel changes and document amendments surface too late.",
  },
  {
    icon: RefreshCw,
    title: "Manual Follow-ups",
    desc: "Hours wasted chasing status updates that should arrive automatically.",
  },
];

export default function ProblemSection() {
  return (
    <section
      id="problems"
      data-testid="problems-section"
      className="py-24 md:py-32 bg-slate-50/60 border-y border-slate-100"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="text-xs tracking-[0.18em] uppercase font-bold text-[#3B82F6]">
            The Problem
          </div>
          <h2 className="mt-3 font-display font-extrabold text-4xl md:text-5xl tracking-[-0.02em] text-[#0B1F3A]">
            Why freight booking is still
            <br />
            <span className="text-[#0B1F3A]/55">too complicated.</span>
          </h2>
          <p className="mt-5 text-lg text-slate-600 max-w-2xl">
            Importers stitch together inboxes, spreadsheets and carrier portals
            just to move a single container out of Turkey. DeMaxtore replaces
            that chaos with one connected Workspace.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {PROBLEMS.map((p, i) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                data-testid={`problem-card-${i}`}
                className="group relative rounded-2xl bg-white border border-slate-200 p-7 hover:border-[#0B1F3A]/20 hover:shadow-[0_18px_40px_-20px_rgba(11,31,58,0.18)] transition-all duration-300"
              >
                <div className="flex items-center justify-center h-11 w-11 rounded-xl bg-slate-50 border border-slate-100 text-slate-500 group-hover:text-[#3B82F6] group-hover:bg-[#3B82F6]/8 transition-colors">
                  <Icon className="h-5 w-5" strokeWidth={1.75} />
                </div>
                <h3 className="mt-5 font-display font-bold text-xl text-[#0B1F3A] tracking-tight">
                  {p.title}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-slate-600">
                  {p.desc}
                </p>
                <span className="absolute top-6 right-6 font-mono text-[10px] text-slate-300">
                  0{i + 1}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
